export const MESSAGE_LIMIT = 159;
export const localStorageKeyForRoomId = 'account.dashboard.invite.room-id';
export const localStorageKeyForCustomText = 'account.dashboard.invite.text';
export const localStorageDefaultKeyForCustomText = 'account.dashboard.invite.text';
export const DEFAULT_PHONE_PLACEHOLDER = '+1 201 555 0123';
